import { Box, Typography } from "@mui/material"
import { DisplayBoxBase } from "../../../../components/shared/StyledComponents"
import { IMeeting, SchedulerType } from "../../../../types"
import { DateDisplay } from "../../../meeting/components/DateDisplay"
import { AdvisorCompany } from "../../../advisor/components/AdvisorCompany";
import { AdvisorProfileSummary } from "../../../advisor/components/AdvisorProfileSummary";
import { useEffect, useState } from "react";
import ClientProvider from "../../../../modules/ClientProvider";
import { useDealContext } from '../../../deal/context';
import { useAuth0 } from "@auth0/auth0-react";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { Link } from "react-router-dom";
import { CalendarHeart } from "lucide-react";

dayjs.extend(utc);
dayjs.extend(timezone);


export const UpcomingMeetings = () => {

    const { dealContext } = useDealContext();
    const [meetings, setMeetings] = useState<IMeeting[]>([]);
    const projectClient = ClientProvider.provideProjectClient();
    const { getAccessTokenSilently } = useAuth0();
    const project = dealContext?.project;

    
    const sortedMeetings = meetings.filter((meeting) => meeting.status === "scheduled" && meeting.event_start && new Date(meeting.event_start) > new Date()).sort((a, b) => {
        return new Date(a.event_start || new Date()).getTime() - new Date(b.event_start || new Date()).getTime();
    });

    useEffect(() => {
        const fetchMeetings = async () => {
            const accessToken = await getAccessTokenSilently();
            const { data, error } = await projectClient.getMeetings(project?.id, accessToken);
            if (data.meetings) {
                setMeetings(data.meetings);
            }
        }
        fetchMeetings();
    }, []);

    return (
        <Box sx={{ width: "100%", height: "100%", minHeight: 0, display: "flex", flexDirection: "column", gap: 1 }}>
            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: "1rem", width: "100%", marginBottom: "1rem" }}>
                <Typography variant="body1" sx={{ fontWeight: 600, marginBottom: 0 }}><CalendarHeart size={16} style={{marginBottom: "2px"}}/> Upcoming Meetings</Typography>
                <Typography variant="body2" sx={{ color: "#7b8a99", fontWeight: 600 }}>
                    <Link to="/c/meetings">
                        See all
                    </Link>
                </Typography>
            </Box>
            <DisplayBoxBase
                className="white column"
                sx={{
                    gap: 2,
                    width: "100%",
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                }}
            >
                {sortedMeetings.slice(0, 4).map((meeting) => (
                    <Box key={meeting.id} sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: "1rem", width: "100%" }}>
                        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: "1rem", flex: "0 0 53px"}}>
                            <DateDisplay meeting={meeting} showTime={true} />
                        </Box>
                        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: "1rem", width: "100%" }}>
                            <Box sx={{ flex: "1 1 200px"}}>
                                <Typography variant="body1" sx={{ fontWeight: 600}}>{meeting.project?.effective_scheduler_properties?.[meeting.scheduler?.type as SchedulerType]?.name ?? "Intro"}</Typography>
                                <Typography variant="body2" sx={{ color: "#7b8a99", fontWeight: 400 }}>
                                    {dayjs(meeting.event_start).tz(dayjs.tz.guess()).format("h:mm A z")}
                                </Typography>
                            </Box>
                            <Box sx={{ flex: "1 0 180px"}}>
                                <AdvisorProfileSummary advisor={meeting.advisor} showCompany={true} showImage={true} />
                            </Box>
                        </Box>
                    </Box>
                ))}
                {sortedMeetings.length === 0 && (
                    <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "1rem", width: "100%" }}>
                        <Typography variant="body2" sx={{ color: "#7b8a99", fontWeight: 400, fontSize: "14px", marginTop: "4rem" }}>
                            No upcoming meetings
                        </Typography>
                    </Box>
                )}
            </DisplayBoxBase>
        </Box>
    )
}